import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const MyProgress = ({
  v1,
  v2,
  textSize,
  textColor,
  pathColor,
  trailColor,
  strokeWidth,
  width = 135,
  height = 135,
}) => {
  const percentage = (v1 / v2) * 100;

  return (
    <div style={{ width, height}}>
      <CircularProgressbar
        value={percentage}
        text={`${v1}\n/${v2}`}
        strokeWidth={strokeWidth}
        styles={buildStyles({
          textSize,
          textColor,
          pathColor,
          trailColor,
        })}
      />
    </div>
  );
};


export default MyProgress